export default "<div class=\"page\"></div>\r\n";